import { BusinessBaseModel, BusinessModel, BusinessTypeBaseModel } from 'API/Generated/data-contracts';
import { GetUserStore } from 'SessionState/User/UserStore';
import { Formik, Form as FormikForm } from 'formik';
import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react';
import * as Yup from 'yup';
import { IImage } from 'views/components/ImageUpload';
import { GetBusinessStore } from 'SessionState/Business/BusinessStore';
import AddEditBusinessForm from './AddEditBusinessForm';
import { handleWebsiteLink } from 'helpers/fileHelpers';
import { BlockFromCurrentUserWrapper } from 'views/default/Wrappers';
import UpgradeDirectorMembership from 'views/default/UpgradeDirectorMembership';

interface AddEditBusinessModalProps {
  addEditBusinessModal: boolean;
  setAddEditBusinessModal: (addEditBusinesstModal: boolean) => void;
  business: BusinessModel | undefined;
}

// export interface IBusinessValues {
//   id: number | undefined;
//   name: string;
//   startDate: string;
//   type: BusinessTypeBaseModel | undefined;
//   businessLogo: undefined;
//   // businessUserId: number[] | undefined;
// }

interface IAddEditBusinessValues extends BusinessBaseModel, IImage {
}

const AddEditBusinessModal = (props: AddEditBusinessModalProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const businessStore = GetBusinessStore();
  const userStore = GetUserStore();

  const otherValidationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required.').max(100, 'Name must be 100 characters or less.'),
    startDate: Yup.date(),

    type: Yup.object().shape({
      id: Yup.number().required('Business Type is required'),
    }),
    phoneNumber: Yup.string().max(12, 'Phone Number must be 12 characters or less.'),
    email: Yup.string().email(),
    website: Yup.string().url(),
    // city: Yup.string().max(100, 'City must be 100 characters or less.'),
    // stateId: Yup.number().required('State is Required'),
    about: Yup.string().max(255, 'About must be 255 characters or less.'),
    isHeadOwner: Yup.boolean().isTrue(),
    isActive: Yup.boolean().isTrue(),
    industryStyleTypeIds: Yup.array().of(Yup.number().min(1)).min(1, 'Please select at least one Business Industry.')
  });


  const initialValues: IAddEditBusinessValues = {
    id: props?.business?.id ?? 0,
    name: props.business?.name ?? '',
    startDate: props.business?.startDate ?? '',
    isActive: props.business?.isActive ?? true,
    about: props.business?.about ?? '',
    website: handleWebsiteLink(props.business?.website ?? ''),
    // city: props.business?.city ?? '',
    // stateId: props.business?.stateId,
    // type: undefined,
    businessLogo: props.business?.businessLogo ?? { id: 0, image: '', imageName: '', imageType: '' },
    image: {
      id: props.business?.businessLogo?.id ?? 0,
      image: props.business?.businessLogo?.image ?? '',
      imageName: props.business?.businessLogo?.imageName ?? '',
      imageType: props.business?.businessLogo?.imageType ?? ''
    }
  };

  // const addBusiness = (values: IAddEditBusinessValues, reset) => {
  //   setIsLoading(true);
  //   console.log(values);
  //   values.businessLogo = {...values.image}
  //   businessStore.addBusiness(values).then((success) => {
  //     if (success) {
  //       toast.success('Business Saved Successfully');
  //       // businessStore.set.setLoggedInUser();
  //       setIsLoading(false);
  //       props.setAddEditBusinessModal(false);
  //       reset();
  //     } else {
  //       toast.error('Error Saving Business');
  //       setIsLoading(false);
  //     }
  //   });
  // };

  const saveItem = (values, reset) => {
    setIsLoading(true);
    console.log('SaveItem', values);
    values.businessLogo = {...values.image}
    let newBusiness: BusinessModel = {
      id: values.id ?? 0,
      name: values.name,
      startDate: values.startDate,
      isActive: values.isActive,
      about: values.about,
      city: values.city,
      stateId: values.stateId,
      website: handleWebsiteLink(values.website),
      // stateId: values.stateId,
      businessTypeId: values.type.id,
      businessLogo: values.businessLogo,
    };

    businessStore.addBusiness(newBusiness).then((response) => {
      if (!response) {
        toast.error('Error saving business', { position: toast.POSITION.TOP_RIGHT });
      } else {
        toast.success('Business saved successfully', { position: toast.POSITION.TOP_RIGHT });
        // businessStore.setShowModal(false);
        props.setAddEditBusinessModal(false);
        reset();
      }
      businessStore.refreshCurrentBusiness();
      setIsLoading(false);
    });
  };




  // useEffect(() => {
  //   const getBusiness = async () => {
  //     const currentBusiness = businessStore.CurrentBusiness;

  //     const values: IBusinessValues = {
  //       id: currentBusiness?.id ? currentBusiness?.id : undefined,
  //       name: currentBusiness?.name ? currentBusiness?.name : '',
  //       startDate: currentBusiness?.startDate ? currentBusiness?.startDate : '',
  //       type: currentBusiness?.businessType ? currentBusiness?.businessType : undefined,
  //       // businessUserId: currentBusiness?.map(x => x.userIds ?? 0) : undefined
  //       //TODO: Figure out this Mapping
  //     };
  //     setSelectedItem(values);
  //   };
  //   getBusiness();
  // }, []);

  // const addBusiness = (values: IAddEditBusinessValues, reset) => {
  //   setIsLoading(true);
  //   console.log(values);
  //   businessStore.addBusiness(values).then((success) => {
  //     if (success) {
  //       toast.success('Business Saved Successfully');
  //       userStore.setLoggedInUser();
  //       setIsLoading(false);
  //       props.setAddEditBusinessModal(false);
  //       reset();
  //     } else {
  //       toast.error('Error Saving Business');
  //       setIsLoading(false);
  //     }
  //   });
  // };

  return (
    <Modal className=" modal-right large fade" show={props.addEditBusinessModal} onHide={() => props.setAddEditBusinessModal(false)}>
      <Formik
        initialValues={initialValues}
        validationSchema={otherValidationSchema}
        onSubmit={(values, { resetForm }) => {
          console.log('BeforeSave', values);
          saveItem(values, resetForm);
          // addBusiness(values, resetForm)
        }}
      >
        {({ values, resetForm, handleChange, setFieldValue }) => (
          <FormikForm>
            <Modal.Header>
              <Modal.Title>Add New Business</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <BlockFromCurrentUserWrapper ifCurrentUserIsRole={['MiniDirectorMember']} fallback={<UpgradeDirectorMembership />}>
              <AddEditBusinessForm business={props.business} businessIndex={0}/>
              </BlockFromCurrentUserWrapper>
            </Modal.Body>
            <Modal.Footer>
              {/* <Button
                variant="outline-primary"
                onClick={() => {
                  businessStore.setShowModal(false);
                  resetForm();
                }}
              >
                Cancel
              </Button> */}
              <Button variant="outline-primary" onClick={() => { props.setAddEditBusinessModal(false); resetForm(); }}>
                Cancel
              </Button>
              <Button type="submit">{isLoading ? <Spinner as="span" animation="border" size="sm" /> : 'Save Business'}</Button>
            </Modal.Footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
};

export default AddEditBusinessModal;

